import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {
  NH_STYLE_FINGERPRINT_CAPTION,
  readOverviewLines,
} from '../../utils/nhStyleFingerprintSnapshot';
import NhStyleFingerprintHoverInfo from './NhStyleFingerprintHoverInfo';

function OverviewLine({ label, value }) {
  return (
    <Typography variant="body2">
      {label}: {value}
    </Typography>
  );
}

OverviewLine.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

function OverviewPopup({ lines }) {
  return (
    <Box>
      {lines.map((line) => (
        <OverviewLine key={line.label} label={line.label} value={line.value} />
      ))}
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        {NH_STYLE_FINGERPRINT_CAPTION}
      </Typography>
    </Box>
  );
}

OverviewPopup.propTypes = {
  lines: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
};

function NhStyleFingerprintOverview({ snapshot }) {
  const lines = readOverviewLines(snapshot);
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 2 }}>
      <Typography variant="h5" component="h1">
        Overview
      </Typography>
      <NhStyleFingerprintHoverInfo ariaLabel="About overview" popupLabel="Snapshot overview">
        <OverviewPopup lines={lines} />
      </NhStyleFingerprintHoverInfo>
    </Box>
  );
}

NhStyleFingerprintOverview.propTypes = {
  snapshot: PropTypes.shape({
    packagedAt: PropTypes.string,
    calculationVersion: PropTypes.string,
    overview: PropTypes.shape({}),
  }),
};

export default NhStyleFingerprintOverview;
